import React from "react";
import { Container, Icon } from "semantic-ui-react";
import { Content, Hero, Paragraph } from "../layout";

const Page = () => (
  <Content>
    <Hero>Faire un don</Hero>
    <Container text>
      <Paragraph>
        Votre soutien fait une réelle différence dans la poursuite de notre
        mission auprès des personnes en processus de réinsertion sociale. Si
        vous souhaitez contribuer par un don ou obtenir plus d’informations,
        n’hésitez pas à communiquer avec nous. Chaque geste compte et nous vous
        remercions sincèrement de votre générosité.
      </Paragraph>
      <Paragraph>
        Pour faire un don ou poser vos questions, vous pouvez nous écrire à
        l’adresse suivante :
      </Paragraph>
      <Paragraph>
        <Icon name="mail" color="teal" />
        <a href="mailto:dons@transitioncentresud.ca">
          dons@transitioncentresud.ca
        </a>
      </Paragraph>
    </Container>
  </Content>
);

export default Page;
